/**
 * Custom FAQ Section — Tab Switcher
 * Vanilla JS, no dependencies.
 * Handles tab navigation and panel visibility.
 */
(function () {
  'use strict';

  function initFaqSection(container) {
    if (!container) return;

    var tabs = container.querySelectorAll('[data-custom-faq-tab]');
    var panels = container.querySelectorAll('[data-custom-faq-panel]');

    if (tabs.length === 0 || panels.length === 0) return;

    function switchTab(targetId) {
      // Update tabs
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-custom-faq-tab') === targetId;
        tab.classList.toggle('custom-faq__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Update panels
      panels.forEach(function (panel) {
        var isTarget = panel.getAttribute('data-custom-faq-panel') === targetId;
        if (isTarget) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    // Bind click events via delegation
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchTab(this.getAttribute('data-custom-faq-tab'));
      });

      // Keyboard: Enter or Space
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          switchTab(this.getAttribute('data-custom-faq-tab'));
        }
      });
    });
  }

  // Initialize all FAQ sections on the page
  function initAll() {
    document.querySelectorAll('[data-custom-faq-section]').forEach(initFaqSection);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support Shopify theme editor re-renders
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target;
      if (section) {
        var faqContainer = section.querySelector('[data-custom-faq-section]');
        if (faqContainer) {
          initFaqSection(faqContainer);
        }
      }
    });
  }
})();
